import React from "react";

const HomeAdmin=()=>{
     return(<>
     <div>
          <h1>Home admin</h1>
     </div>
     </>);
}

export default HomeAdmin;